import { browserHistory } from 'react-router';
import { AuthActions, UserActions } from '../actions';
import runtimeEnv from '@mars/heroku-js-runtime-env';

class AuthService {
  constructor() {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);

    this._fetchMe = this._fetchMe.bind(this);
    this._navToDashboard = this._navToDashboard.bind(this);

    this.dispatch = () => {};
  }

  _fetchMe(response) {
    if (response.authToken) {
      this.setToken(response.authToken, response.authToken);
    }
    return this.fetch('/user/me');
  }
  _navToDashboard(response) {
    this.dispatch(UserActions.getCompany());
    this.dispatch(AuthActions.storeUserProfile(response));
    this.setProfile(response);

    browserHistory.replace('/dashboard');
  }
  login(username, password, dispatch) {
    this.dispatch = dispatch;
    const env = runtimeEnv();
    const baseUrl = env.REACT_APP_AUTH_URL;
    const headers = this.getAuthorizationHeaders();
    return fetch(baseUrl, {
      headers, 
      method: 'POST',
      body: JSON.stringify({ username, password })
    })
    .then(this._checkStatus)
    .then(this._handleContent)
    .then(this._fetchMe)
    .then(this._navToDashboard)
    .catch(e => {
      console.log(e);
      return e;
    });
  }

  parseHash(hash, dispatch) {
    // this.auth0.parseHash({ hash }, (err, authResult) => {
    //   if (authResult && authResult.accessToken && authResult.idToken) {
    //     this.setToken(authResult.accessToken, authResult.idToken);
    //     browserHistory.replace('/dashboard');
    //     this.auth0.client.userInfo(authResult.accessToken, (error, profile) => {
    //       if (error) {
    //         console.log('Error loading the Profile', error)
    //       } else {
    //         dispatch(AuthActions.storeAuth(this));
    //         this.fetch(`/user/${profile.sub}`).then((prof) => {
    //           dispatch(AuthActions.storeUserProfile(prof));
    //           this.setProfile(prof);
    //         });
    //       }
    //     });
    //   } else if (authResult && authResult.error) {
    //     alert('Error: ' + authResult.error);
    //   }
    // });
  }

  saveToState(dispatch) {
    return dispatch(AuthActions.storeAuth(this));
  }

  loggedIn() {
    const token = this.getToken();
    return !!token;
  }

  setToken(accessToken, idToken) {
    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('id_token', idToken);
  }

  getToken() {
    return localStorage.getItem('id_token');
  }

  setProfile(profile) {
    localStorage.setItem('profile', JSON.stringify(profile));
  }
  getProfile() {
    const profile = localStorage.getItem('profile');
    return profile ? JSON.parse(localStorage.profile) : {};
  }

  _checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response
    } else {
      if (response.status === 401) {
        this.logout();
        browserHistory.push('/login');
      }
      var error = new Error(response.statusText)
      error.response = response
      throw error
    }
  }

  _handleContent(response) {
    if (response.status !== 204) {
      return response.json();
    }
    return null;
  }

  getAuthorizationHeaders() {
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    if (this.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.getToken();
    }
    return headers;
  }

  fetch(urlPath, options) {
    const env = runtimeEnv();
    const baseUrl = env.REACT_APP_API_URL;

    const headers = (options && options.headers) ? options.headers : {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    if (this.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.getToken();
    }
    return fetch(`${baseUrl}${urlPath}`, {
      headers,
      ...options
    })
      .then(this._checkStatus) // to raise errors for wrong status
      .then(this._handleContent) // to parse the response as json
  }

  logout(dispatch) {
    if (dispatch) {
      dispatch(UserActions.logoutUser());
    }
    localStorage.removeItem('id_token');
    localStorage.removeItem('access_token');
    localStorage.removeItem('profile');
    try {
      localStorage.removeItem('order');
      localStorage.removeItem('fromLocation');
      localStorage.removeItem('toLocation');
    } catch (e) {
      // do nothing...
    }
  }
};

export default AuthService;



// WEBPACK FOOTER //
// ./src/services/AuthService.js